var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSettings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99984 2.99999C11.2832 2.99999 12.3332 4.04999 12.3332 5.33332C12.3332 6.61666 11.2832 7.66666 9.99984 7.66666C8.7165 7.66666 7.6665 6.61666 7.6665 5.33332C7.6665 4.04999 8.7165 2.99999 9.99984 2.99999ZM9.99984 14.6667C13.1498 14.6667 16.7665 16.1717 16.9998 17H2.99984C3.26817 16.16 6.8615 14.6667 9.99984 14.6667ZM9.99984 0.666656C7.4215 0.666656 5.33317 2.75499 5.33317 5.33332C5.33317 7.91166 7.4215 9.99999 9.99984 9.99999C12.5782 9.99999 14.6665 7.91166 14.6665 5.33332C14.6665 2.75499 12.5782 0.666656 9.99984 0.666656ZM9.99984 12.3333C6.88484 12.3333 0.666504 13.8967 0.666504 17V19.3333H19.3332V17C19.3332 13.8967 13.1148 12.3333 9.99984 12.3333Z",
    fill: "#091F82"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.808131a3dc556de6ee0b1aafbcd2acdc.svg";
export { ForwardRef as ReactComponent };